export default [{
    path: 'position',
    component: () => import('@/views/organization/position/position.main'),
    children: [
        {
            name: 'positionList',
            path: 'list',
            components: {
                list: () => import('@/views/organization/position/position.list'),
            },
        },
        {
            name: 'positionDetail',
            path: 'detail',
            components: {
                detail: () => import('@/views/organization/position/position.detail'),
            },
        }
        ]
}]